import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import * as styles from './style/index.scss'
import { Button, Modal } from 'antd-mobile'
import icon_computer from '@assets/img/icon_computer.png'
import device_bg from '@assets/img/device_bg.png'
import device_bg2 from '@assets/img/device_bg2.png'
import icon_iccid from '@assets/img/icon_iccid.png'
import icon_iccid2 from '@assets/img/icon_iccid2.png'
import IconEdit from '@assets/img/global/edit.png'
import { FormattedMessage } from 'react-intl'
import intl from '@utils/intl'

const alert = Modal.alert;
const prompt = Modal.prompt;

interface ItemProps {
    dto?: any  // 设备实体对象
    switchDevice?: (options: any) => void
    editNickName?: (simId: string, value: string) => void
}

class DeviceItem extends ComponentExt<ItemProps> {
    private readonly userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}

    constructor(props) {
        super(props)
    }

    switchDevice = (simId, operatorsId) => {
        const title = intl.formatMessage({ id: 'device.switch.alert.title' })
        const content = intl.formatMessage({ id: 'device.switch.alert.content' })
        const OK = intl.formatMessage({ id: 'common.sure' })
        const cancel = intl.formatMessage({ id: 'common.cancel' })
        alert(title, content, [
            { text: cancel },
            { text: OK, onPress: () => this.props.switchDevice({ simId, operatorsId }) }
        ])
    }

    editNickName = (simId, defaultValue) => {
        const title = intl.formatMessage({ id: 'device.switch.alert.title' })
        const message = intl.formatMessage({ id: 'device.edit.prompt.message' })
        const OK = intl.formatMessage({ id: 'common.sure' })
        const cancel = intl.formatMessage({ id: 'common.cancel' })
        const checkNone = intl.formatMessage({ id: 'device.edit.check.none' })
        prompt(title, message, [
            { text: cancel },
            {
                text: OK, onPress: value => new Promise((resolve, reject) => {
                    if (!value) {
                        this.$toast.info(checkNone)
                        reject()
                    } else {
                        this.props.editNickName(simId, value)
                        resolve()
                    }
                })
            }
        ], 'default', defaultValue)
    }

    dealNickName = (item) => {
        if (item.nicknameCustome !== '1' && item.nickName.indexOf('我的电脑') > -1) {
            item.nickName = item.nickName.replace('我的电脑', intl.formatMessage({ id: 'me.nav.device' }))
            return item.nickName
        } else {
            return item.nickName
        }
    }
    replaceName = (nickName) => {
        const deviceName = nickName.replace('我的电脑', intl.formatMessage({ id: 'me.nav.device' }))
        return deviceName
    }

    render() {
        const { nickName, simId, operatorsId } = this.props.dto
        const deviceName = this.replaceName(nickName)
        const isCurrent = simId === this.userInfo.iccid
        return (
            <div className={styles.deviceItem}>
                <div className={styles.deviceHeader}>
                    <img src={icon_computer} className={styles.iconComputer} />
                    <span>{this.dealNickName(this.props.dto)}</span>
                    <img src={IconEdit} className={styles.iconEdit} onClick={() => this.editNickName(simId, deviceName)} />
                    {
                        !isCurrent &&
                        <Button className={styles.switchBtn} onClick={() => this.switchDevice(simId, operatorsId)}>
                            <FormattedMessage id="device.switch" />
                        </Button>
                    }
                </div>
                <div className={styles.deviceInfoWrapper}>
                    <div
                        className={styles.innerInfoWrap}
                        style={{ backgroundImage: `url(${isCurrent ? device_bg : device_bg2})` }}
                    >
                        <img src={isCurrent ? icon_iccid : icon_iccid2} className={styles.iconIccid} />
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <p style={{ color: isCurrent ? '#eb6a1a' : '#1B334C' }}>ICCID:</p>
                            <span>{simId}</span>
                        </div>
                        <div
                            className={styles.deviceStatus}
                            style={{ background: isCurrent ? 'linear-gradient(300deg, rgba(235, 106, 26, 1) 0%, rgba(255, 151, 90, 1) 100%)' : 'linear-gradient(300deg,rgba(27,51,76,1) 0%,rgba(142,156,171,1) 100%)' }}
                        >
                            <FormattedMessage id={isCurrent ? 'device.status.current' : 'device.status.available'} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DeviceItem
